import { isFrrAppliedOnAllStages } from '../../basicTaskList/utils/basicStageList';
import { ResponseReuseType } from '../constants';
import { Task } from '../interfaces';
import { RRMessageProps } from '../../basicTaskList/components/layout_01/BasicTaskListLayout';

interface GetAdvancedResponseReuseInfoReturnType {
  isRRApplied: boolean;
  rrPopupInfo: RRMessageProps;
  frrAppliedOnAllStages: boolean;
}

const getAdvancedResponseReuseInfo = (tasks: Task[]): GetAdvancedResponseReuseInfoReturnType => {
  let isRRApplied = false;
  let frrAppliedOnAllStages = false;
  let rrPopupInfo = {
    buttonText: '',
    title: '',
    subtitle1: '',
    subtitle2: '',
    subtitle3: '',
  };

  if (tasks.length) {
    const isFrrOrPrrApplied: boolean = tasks.some(
      (task) =>
        task.responseReuseType === ResponseReuseType.FULL_RR || task.responseReuseType === ResponseReuseType.PARTIAL_RR,
    );

    if (isFrrOrPrrApplied) {
      frrAppliedOnAllStages = isFrrAppliedOnAllStages(tasks);

      const rrMessageInfo: RRMessageProps = {
        buttonText: 'rrProceedButton',
        title: 'rrPopupTitle',
        subtitle1: 'frrPopupSubTitle1',
        subtitle2: 'rrPopupSubTitle2',
        subtitle3: 'rrPopupSubTitle3',
      };

      if (!frrAppliedOnAllStages) {
        rrMessageInfo.subtitle1 = 'prrPopupSubTitle4';
        rrMessageInfo.buttonText = 'gotIt';
      }

      rrPopupInfo = rrMessageInfo;
      isRRApplied = isFrrOrPrrApplied;
    }
  }

  return { isRRApplied, rrPopupInfo, frrAppliedOnAllStages };
};

export default getAdvancedResponseReuseInfo;
